import { useMemo } from 'react';

export const useSupplyProgress = (totalDeposited: string, totalDepositThreshold: string) => {
    return useMemo(
        () => Math.round((Number(totalDeposited) / Number(totalDepositThreshold)) * 100),
        [totalDeposited, totalDepositThreshold],
    );
};
